import { BaseStoreInterface } from '@interface/store/base-store.interface';
import { WebhookInterface } from '@interface/webhook/webhook.interface';
import { BaseStoreStructure } from '@util/constants/store.constants';

export const initialWebhooksState: BaseStoreInterface<Record<string, WebhookInterface>> = {
  ...BaseStoreStructure,
  data: {},
};
